import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { auditService } from '../../services/auditService';
import { AuditEvent } from '../../types/audit';

export const AuditDetailPage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const [event, setEvent] = useState<AuditEvent | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchEvent = async () => {
      if (!id) return;
      
      try {
        setLoading(true);
        setError(null);
        const eventData = await auditService.getAuditEventById(id);
        setEvent(eventData);
      } catch (err) {
        setError('Erro ao carregar detalhes do evento. Tente novamente.');
        console.error('Erro ao buscar evento:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchEvent();
  }, [id]);

  if (loading) {
    return (
      <div className="p-6">
        <div className="flex items-center justify-center">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
          <span className="ml-2">Carregando...</span>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-6">
        <Link to="/audit" className="text-blue-600 hover:underline mb-4 inline-block">&larr; Voltar para auditoria</Link>
        <div className="bg-red-50 border border-red-200 rounded-lg p-4">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <svg className="h-5 w-5 text-red-400" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="ml-3">
              <h3 className="text-sm font-medium text-red-800">Erro ao carregar dados</h3>
              <div className="mt-2 text-sm text-red-700">
                <p>{error}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (!event) {
    return (
      <div className="p-6">
        <Link to="/audit" className="text-blue-600 hover:underline mb-4 inline-block">&larr; Voltar para auditoria</Link>
        <div className="bg-yellow-50 border border-yellow-200 rounded-lg p-4">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <svg className="h-5 w-5 text-yellow-400" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z" clipRule="evenodd" />
              </svg>
            </div>
            <div className="ml-3">
              <h3 className="text-sm font-medium text-yellow-800">Evento não encontrado</h3>
              <div className="mt-2 text-sm text-yellow-700">
                <p>O evento de auditoria solicitado não foi encontrado.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="p-6 max-w-2xl mx-auto">
      <Link to="/audit" className="text-blue-600 hover:underline mb-4 inline-block">&larr; Voltar para auditoria</Link>
      <h1 className="text-2xl font-bold mb-4">Detalhes do Evento de Auditoria</h1>
      <div className="bg-white rounded-lg shadow p-6">
        <div className="mb-4"><span className="font-medium">Data/Hora:</span> {new Date(event.createdAt).toLocaleString('pt-BR')}</div>
        <div className="mb-4"><span className="font-medium">Usuário:</span> {event.userName}</div>
        <div className="mb-4"><span className="font-medium">Email:</span> {event.email}</div>
        <div className="mb-4"><span className="font-medium">Ação:</span> {event.actionName}</div>
        <div className="mb-4"><span className="font-medium">Descrição da Ação:</span> {event.actionDescription}</div>
        <div className="mb-4"><span className="font-medium">Documento:</span> {event.documentName}</div>
        <div className="mb-4"><span className="font-medium">Detalhes da Ação:</span> {event.actionDetails}</div>
        <div className="mb-4"><span className="font-medium">ID do Documento:</span> {event.documentId}</div>
        <div className="mb-4"><span className="font-medium">ID do Usuário:</span> {event.userId}</div>
      </div>
    </div>
  );
}; 